<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import SectionBoard from "../../molecules/SectionBoard.svelte";

  let loading = false;
  let inquiryWebhook = "";
  let id = 0;

  onMount(async () => {
    const client = ApiService.createClient();
    const { data } = await client.get("/webhooks");

    data.webhooks.forEach((w) => {
      if (w.masterWebhook.label === "問い合わせ") {
        inquiryWebhook = w.url;
        id = w.id;
      }
    });
  });

  const handleInquiryWebhookUrl = (event) => {
    inquiryWebhook = event.detail.value;
  };

  const saveInquiryWebhook = async () => {
    const client = ApiService.createClient();
    loading = true;
    const { data } = await client.post("/webhook", {
      id,
      webhookId: 1,
      name: "問い合わせ",
      url: inquiryWebhook,
    });
    console.log(data);
    loading = false;
  };

  const testInquiryWebhook = async () => {
    const client = ApiService.createClient();
    loading = true;
    const { data } = await client.get("/webhook/send/1");
    console.log(data);
    loading = false;
  };
</script>

<SectionBoard>
  <h2 class="font-semibold">Webhook設定</h2>

  <div class="mt-6">
    <FormWithLabel
      label="問い合わせ"
      placeholder=""
      input={handleInquiryWebhookUrl}
      value={inquiryWebhook}
    />
  </div>

  <BlueButton rounded klass="mt-4" click={saveInquiryWebhook} {loading}
    >更新する</BlueButton
  >

  <BlueButton rounded klass="mt-4 w-40" click={testInquiryWebhook} {loading}
    >テスト送信する</BlueButton
  >
</SectionBoard>
